<template>
  <div>
    <v-btn
      tile
      elevation="0"
      color="primary"
      @click.stop="drawer = !drawer"
      class="menuBtn"
    >
      <v-icon>mdi-menu</v-icon>
    </v-btn>
    <v-navigation-drawer v-model="drawer" fixed right temporary width="400">
      <v-list nav class="pa-0 mt-8">
        <v-list-item class="d-flex align-center">
            <h3 class="mb-0 ml-6">Pages</h3>
            <v-btn
              @click.stop="drawer = !drawer"
              icon color="primary"
              style="margin-left:auto"
              class="ml-auto mr-6"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-list-item>
        <v-list-item-group>
          <v-list-item
            v-for="item in menuItems"
            :key="item.navTitle"
            :href="item.href"
            target="_blank"
            class="b-b mb-0 pl-8"
          >
            {{ item.navTitle }}
            <v-icon class="ml-auto mr-4">
              mdi-open-in-new
            </v-icon>
          </v-list-item>
          <v-list-item
            :href="PUBLIC_SITE_BASE_URL"
            target="_blank"
            class="b-b mb-0 pl-8"
          >
            Get to know Finland
            <v-icon class="ml-auto mr-4">
              mdi-open-in-new
            </v-icon>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>
<script>
const PUBLIC_SITE_BASE_URL = 'https://workinfinland.com';

export default {
  data: () => ({
    drawer: false,
    PUBLIC_SITE_BASE_URL,
    menuItems: [
      {
        navTitle: 'Open positions',
        href: `${PUBLIC_SITE_BASE_URL}/open-jobs`,
      },
      {
        navTitle: 'About',
        href: `${PUBLIC_SITE_BASE_URL}/about-us`,
      },
      {
        navTitle: 'For employers',
        href: `${PUBLIC_SITE_BASE_URL}/employers`,
      },
      {
        navTitle: 'Privacy policy',
        href: `${PUBLIC_SITE_BASE_URL}/privacy-statement`,
      },
      {
        navTitle: 'Terms of service',
        href: `${PUBLIC_SITE_BASE_URL}/terms-of-use`,
      },
    ],
  }),
};
</script>
<style>
h3{
    color: #002ea1;
    margin: 0;
}
.v-list-item {
  text-transform: uppercase;
  font-size: 18px;
}
.menuBtn{
  position: absolute;
  top:0;
  right:0;
  min-height: 86px;
  width: 86px;
  display: block;
  z-index: 1;
}
@media screen and (max-width: 600px) {
  .menuBtn{
    min-height: 75px;
    width: 75px;
  }
}
</style>
